var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tab"},_vm._l((_vm.games),function(item){return _c('div',{key:item.id,class:['tab_item', _vm.active === item.id && 'tab_item__active'],on:{"click":function($event){return _vm.handleActive(item.id)}}},[_vm._v(" "+_vm._s(item.name)+" "),_c('div',{staticClass:"line"})])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }